import { all, call, fork, put, takeEvery, select } from 'redux-saga/effects';

// action creators
import { doneIndicator } from 'store/actions/httpActions';

// api
import client from 'sources/api';

// constants
import { VOTE_CREATE_REQUEST, VOTE_CREATE } from 'store/constants/voteTypes';

// selectors
import getCurrentGroupId from 'store/selectors/getCurrentGroupId';

// schemas
import { voteSchema } from 'store/schemas/voteSchema';

// helpers
import httpSaga from 'store/sagas/httpSaga';

const WATCH_TYPE = VOTE_CREATE_REQUEST;
const TYPE = VOTE_CREATE;

export function* createVote(action: any) {
  const {
    payload: {
      leadId: lead_id,
      fields: { value, comment },
      formName,
    },
  } = action;

  const currentGroupId = yield select(getCurrentGroupId);

  // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
  yield* httpSaga(
    TYPE,
    call(client.post, `/votes?group_id=${currentGroupId}&lead_id=${lead_id}`, {
      value,
      comment,
    }),
    { schema: voteSchema, formName }
  );

  yield put(doneIndicator(TYPE));
}

export function* watch() {
  yield takeEvery(WATCH_TYPE, createVote);
}

export default function* root() {
  yield all([fork(watch)]);
}
